import { Injectable } from '@angular/core';

@Injectable()
export class AppLoaderService {
  public displaySpinner: boolean = false;
  public displaySpinnerNonHttpCalls: boolean = false;

  constructor() {/**/ }

  public show(): void {
    this.displaySpinner = true;

  }

  // public showLoderNonHttpCalls(): void {
  //   this.displaySpinnerNonHttpCalls = true;
  // }

  // public hideLoderNonHttpCalls(): void {
  //   this.displaySpinnerNonHttpCalls = false;
  // }

  public hide(): void {
    this.displaySpinner = false;

  }

}
